import { render } from "./EinfachSortieren.vue?vue&type=template&id=73a5e10c&scoped=true"
import script from "./EinfachSortieren.vue?vue&type=script&lang=js"
export * from "./EinfachSortieren.vue?vue&type=script&lang=js"

import "./EinfachSortieren.vue?vue&type=style&index=0&id=73a5e10c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a5e10c"]])

export default __exports__